import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import { SPACING } from '../../generic/config';
import { Context } from '../../App';
import { User, UserModel } from '../../model/user';
import ModelInput from '../../base-components/ModelInput';
import Card from '../../base-components/Card';
import useModel from '../../base-components/hooks/useModel';
import EditorParent from '@/base-components/EditorParent';
import { isDesktop } from 'react-device-detect';
import UserInstances from './UserInstances';
import { DropdownItem } from '@/api/base/dropdown-item';

const roleDropdownItems: DropdownItem[] = [
    { id: "SUPERUSER", name: "Superuser" },
    { id: "ADMIN", name: "Admin" },
    { id: "USER", name: "User" },
    { id: "VIEWER", name: "Viewer" },
];

const UserPage: React.FC = () => {
    const { translations } = React.useContext(Context);
    const { model, toolbar } = useModel<User>(UserModel);
    const title = model.isNew ? translations.common.registerNew : `${model.object.firstName ?? ""} ${model.object.lastName ?? ""}`.trim() || model.object.username;

    return (
        <EditorParent title={title} description={model.object.username} toolbar={toolbar}>
            <Grid templateColumns={isDesktop ? "repeat(2, 1fr)" : "repeat(1, 1fr)"} gap={SPACING}>
                <GridItem>
                    <Card {...translations.model.user.cards.userInfo} height={"100%"}>
                        <ModelInput title={translations.model.user.username} fieldKey="username" model={model} isDisabled={!model.isNew} />
                        <ModelInput title={translations.model.user.firstName} fieldKey="firstName" model={model} />
                        <ModelInput title={translations.model.user.lastName} fieldKey="lastName" model={model} />
                    </Card>
                </GridItem>
                <GridItem>
                    <Card {...translations.model.user.cards.contactInfo} height={"100%"}>
                        <ModelInput title={translations.model.user.email} fieldKey="email" model={model} />
                        <ModelInput title={translations.model.user.phone} fieldKey="phone" model={model} />
                    </Card>
                </GridItem>
                <GridItem colSpan={isDesktop ? 2 : 1}>
                    <Card {...translations.model.user.cards.accountInfo}>
                        <ModelInput title={translations.model.user.enabled} fieldKey="enabled" model={model} />
                        <ModelInput<User> kind='dropdown' model={model} title={translations.model.user.role} fieldKey="role" dropdownProps={{
                            items: roleDropdownItems,
                            placeholder: "Select role...",
                        }} />
                    </Card>
                </GridItem>
                {!model.isNew && (
                    <GridItem colSpan={isDesktop ? 2 : 1}>
                        <UserInstances model={model} />
                    </GridItem>
                )}
            </Grid>
        </EditorParent>
    );
};

export default UserPage;
